import { loadStripe } from '@stripe/stripe-js';

let STRIPE_PUBLIC_KEY: string =
	import.meta.env.VITE_APP_STRIPE_PUBLIC_KEY_TEST ?? '';

if (
	import.meta.env.VITE_APP_STRIPE_PUBLIC_KEY &&
	window.location.hostname === 'app.biggby.com'
) {
	STRIPE_PUBLIC_KEY = import.meta.env.VITE_APP_STRIPE_PUBLIC_KEY;
}

// Delete after beta
if (
	import.meta.env.VITE_APP_STRIPE_PUBLIC_KEY &&
	window.location.hostname === 'app-staging.biggby.com'
) {
	STRIPE_PUBLIC_KEY = import.meta.env.VITE_APP_STRIPE_PUBLIC_KEY;
}

export const stripe = loadStripe(STRIPE_PUBLIC_KEY);
